import { allEnumValues, TaxRateType } from '@biteinc/enums';
import { SyncableMenuModelSchema } from './syncable_menu_model_schema.js';
export const taxProfileSchema = {
    displayName: 'tax profile',
    type: 'object',
    fields: {
        ...SyncableMenuModelSchema.fields,
        name: {
            type: 'shortString',
            required: true,
        },
        rates: {
            type: 'array',
            elementType: 'object',
            ui: 'accordion',
            uiSubtype: 'TaxRates',
            required: true,
            minCount: 1,
            fields: {
                _id: {
                    type: 'mongoId',
                    isHidden: true,
                    isPermanent: true,
                    required: true,
                },
                posId: {
                    type: 'shortString',
                    isHidden: true,
                    // PDI needs this field to be changeable, so we can't make it permanent
                    // Bureau makes the field to visible for locations using PDI
                },
                i9nId: {
                    type: 'shortString',
                    isHidden: true,
                    isPermanent: true,
                },
                name: {
                    type: 'shortString',
                    required: true,
                },
                value: {
                    type: 'int',
                    subtype: 'float5',
                    required: true,
                    tooltip: {
                        text: 'Percentage values are expressed in decimal form, fixed amounts are expressed in dollar value.',
                    },
                },
                type: {
                    type: 'int',
                    required: true,
                    ui: 'dropdown',
                    values: allEnumValues(TaxRateType),
                },
            },
        },
    },
};
//# sourceMappingURL=tax_profile_schema.js.map